import FBtnMDP, { BtnType } from "@/components/FBtnMDP";
import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FDateFieldMDP from "@/components/form/field/FDateFieldMDP";
import FNumberFieldMDP from "@/components/form/field/FNumberFieldMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";

import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";

import * as Snackbar from "node-snackbar";
import FRemoteAutoCompleteFieldMDP from "@/components/form/field/FRemoteAutoCompleteFieldMDP";
import FCurrencyFieldMDP from "@/components/form/field/FCurrencyFieldMDP";
import FCreditCardFieldMDP from "@/components/form/field/FCreditCardFieldMDP";
import FSelectDateFieldMDP from "@/components/form/field/FDateSelectFieldMDP";
import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";

export default class IncludeCCToAmendmentFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  parent: any;
  constructor({ taskRoot, parent }: { taskRoot: any; parent: any }) {
    super({
      myRefName: "addCreditorFormRef",
      disabled: taskRoot.taskDisabled,
    });
    this.taskRoot = taskRoot;
    this.parent = parent;

    this
    // .addField(new FClCreditorSelectFieldMDP({
    //   dataSelectorKey: "clCreditorId",
    //   label: "Search Client Creditor(Optional)",
    //   parentMDP: this.childMDP,
    //   boundaryClass: "col-4",
    //   onSelect: this.handleClientCreditorChange()
    // }))
    .addField(
      new FRemoteAutoCompleteFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "creditorName",
        label: "Creditor",
        mandatory: true,
        boundaryClass: "col-4",
        queryUrl: "/spineapi/master/search-creditor?creditorName=",
        itemText:""
      })
    )
      .addField(
        new FCurrencyFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "creditorBalance",
          label: "Creditor Balance",
          mandatory: true,
          boundaryClass: "col-4",
        })
      )
      .addField(
        new FCurrencyFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "emiAmount",
          label: "EMI Amount",
          mandatory: true,
          boundaryClass: "col-4",
        })
      )
      .addField(
        new FSelectDateFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "lastDateOfPayment",
          label: "Last Date of Payment",
          mandatory: true,
          boundaryClass: "col-4",
          futureDaysDisabled: true,
        })
      )

      .addField(
        new FSelectFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "debtType",
          label: "Type of Debt",
          mandatory: true,
          boundaryClass: "col-4",
          options: [
            "Credit Card",
            "Personal Loans",
            "Secured",
            "Others (Unsecured)",
          ],
        })
      )

      .addField(
        new FCreditCardFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "accountNumber",
          label: "Credit Card Number",
          mandatory: true,
          boundaryClass: "col-4",
          condition: this.parent.isCreditCard()
        })
      )

      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "accountNumber",
          label: "Account Number",
          mandatory: true,
          boundaryClass: "col-4",
          condition: !this.parent.isCreditCard(),
          // rules: "min:9|max:20",
          rules: "min:4|max:20",
        })
      )
      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "details",
          label: "Details",
        })
      )

      .addAction(
        new FBtnMDP({
          label: "Cancel",
          btnType: BtnType.TEXT,
          onClick: () => {
            this.parent.closeAndClearAllForms()
          },
        })
      )
      .addAction(
        new FFormSubmitBtnMDP({
          label: "Include Creditor",
          onClick: () => this.addCreditor(),
        })
      );
  }

  getMyRef() {
    return this.parent.$refs[this.myRefName];
  }

  addCreditor() {
    const input = Data.ClientFile.UpdateIncludeClCreditorForAmendmentForm.fromJson(
      this.parent.includeCreditorToAmendmentForm
    );
    input.amendmentToken = 
      this.taskRoot.amendmentToken;
      input.skipUnderwrittingRule = true;
      input.clientFileId = (
        this.taskRoot as any
      ).clientFileBasicInfo.clientFileId;
    Action.ClientFile.UpdateIncludeClCreditorForAmendment.execute(input, (output) => {
      this.parent.closeAndClearAllForms();
      Snackbar.show({
        text: "Succesfully included",
        pos: "bottom-center",
      });
    });
  }


  handleClientCreditorChange() {
    return (item: any) => {
      this.parent.handleClientCreditorChange(item);
    }
  }
}
